// extracted by mini-css-extract-plugin
export default {"mainContainer":"modal_mainContainer__yFA0v","container":"modal_container__zLYYF","close":"modal_close__dW+iB","header":"modal_header__WylpV","content":"modal_content__nrtR0"};